import { Box, Drawer, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import HorsePowerSection from "./horse-power";
import TractorFilterSection from "./tractor-filter";
import AttachmentFilterSection from "./attachment-filter";
import HeavyEquipmentFilterSection from "./heavy-equipments-filter";
import PriceFilterSection from "./price-filters";
import MoreFilterSection from "./more-filter";
import { useSearchParams } from "react-router-dom";
import { decodeSearchListingFilters } from "utils/common.util";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import { setSearchAttachmentsIds } from "slices/searchListingReducer";

const options = [
  {
    name: "By Horse Power",
    icon: "/assets/img/icons/horse_pw.svg",
  },
  {
    name: "Tractor",
    icon: "/assets/img/icons/tractor_search.svg",
  },
  {
    name: "Attachment",
    icon: "/assets/img/icons/attachment_search.svg",
  },
  // {
  //   name: "Heavy Equipment",
  //   icon: "/assets/img/icons/heavy_eqp_search.svg",
  // },
  {
    name: "Price",
    icon: "/assets/img/icons/price_search.svg",
  },
  {
    name: "More",
    icon: "/assets/img/icons/setting_search.svg",
  },
];

const ExtraFilters = () => {
  const [activeFilterSection, setActiveFilterSection] = useState(0);
  const [query, setQuery] = useSearchParams();
  const handleDrawerClose = () => setActiveFilterSection(0);
  const dispatch = useAppDispatch();
  const { searchAttachmentIds }: any = useAppSelector(
    (state) => state.searchListingReducer
  );
  useEffect(() => {
    let attachmentfilters: any = query.get("attachmentfilters");
    if (attachmentfilters) {
      attachmentfilters = decodeSearchListingFilters(attachmentfilters);
      dispatch(
        setSearchAttachmentsIds([...searchAttachmentIds, ...attachmentfilters])
      );
      query.delete("attachmentfilters");
      setQuery(query);
    }
  }, [query]);

  const section = (i: number) => {
    if (i === 1) return <HorsePowerSection onClose={handleDrawerClose} />;
    if (i === 2) return <TractorFilterSection onClose={handleDrawerClose} />;
    if (i === 3) return <AttachmentFilterSection onClose={handleDrawerClose} />;
    // if (i === 4)
    //   return <HeavyEquipmentFilterSection onClose={handleDrawerClose} />;
    if (i === 4) return <PriceFilterSection onClose={handleDrawerClose} />;
    if (i === 5) return <MoreFilterSection onClose={handleDrawerClose} />;
    else return null;
  };

  return (
    <Box
      key="box"
      sx={{ borderBottom: "1px solid #E2E2E2", px: "3%", py: "15px" }}
    >
      <Box
        sx={{
          display: {
            md: "flex",
            lg: "flex",
            xl: "flex",
            sm: "none",
            xs: "none",
          },
          gap: "34px",
        }}
      >
        {options.map((opt, index) => (
          <Box
            sx={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
              cursor: "pointer",
            }}
            role="button"
            onClick={() => setActiveFilterSection(index + 1)}
          >
            <img src={opt.icon} width="24px" />
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: "15px",
                lineHeight: "19px",
              }}
            >
              {opt.name}
            </Typography>
            <img
              src="/assets/img/icons/arrow_down.svg"
              height="24"
              width="24"
            />
          </Box>
        ))}
      </Box>

      <Drawer
        anchor="right"
        open={activeFilterSection > 0}
        onClose={() => setActiveFilterSection(0)}
      >
        {section(activeFilterSection)}
      </Drawer>
    </Box>
  );
};

export default ExtraFilters;
